import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { i18n } from '../../translate/i18n';
import DefaultValuesUtils from '../../utils/classes/DefaultValuesUtils';

const useStyles = makeStyles(theme => ({
  anchor: {
    color: theme.palette.secondary.ackCheck
  }

  , floatingButton: {
    transition: 'transform 0.30s'
    , '&:hover': { transform: 'translateY(-5px)' }
  }
}));

const MediaNotSupportedModal = ({ open, onClose, medias }) => {
  //  ****************
  //  ** Attributes **
  //  ****************
  const classes = useStyles();
  const [message, setMessage] = useState('');

  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    if (!open) return;
    if (medias.length === 0) return;
    setMessage(medias.join(', '));
  }, [open, medias]);

  //  *************
  //  ** Methods **
  //  *************
  const handleClose = () => {
    onClose();
    setTimeout(() => setMessage(''), 100);
  };

  //  ************
  //  ** Return **
  //  ************
  return (
    <Dialog open={open} onClose={handleClose} maxWidth='xs' scroll='paper' fullWidth>
      <DialogTitle>
        <span>{i18n.t('mediaNotSupportedModal.title')}</span>
      </DialogTitle>

      <DialogContent>
        <Typography>
          {i18n.t('mediaNotSupportedModal.descriptionMedias').replace('<param>', message)}
        </Typography>

        <br />

        <Typography>
          {i18n.t('mediaNotSupportedModal.descriptionSupportedList')}
          
          <a className={classes.anchor} href={DefaultValuesUtils.URLS.officialApi.supportedMediasUrl} target='_blank' rel='noreferrer'>
            {i18n.t('mediaNotSupportedModal.supportedMediasList')}.
          </a>
        </Typography>

        <br />

        <Typography>
          {i18n.t('mediaNotSupportedModal.descriptionLocalhostMedia')}
        </Typography>

        <br />
      </DialogContent>

      <DialogActions>
        <Button color='inherit' variant='outlined' className={classes.floatingButton} onClick={handleClose}>
          {i18n.t('mediaNotSupportedModal.buttons.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MediaNotSupportedModal;
